import { useState } from "react";
import { recommendList, themeTags } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function RecommendSection() {
  const [activeTag, setActiveTag] = useState("全部");

  const filtered =
    activeTag === "全部"
      ? recommendList
      : recommendList.filter((item) => item.tags.includes(activeTag));

  return (
    <section id="recommend" className="w-full bg-background-100 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="题材推荐"
          title="点一个题材，直接看同类作品"
          desc="下方作品同时带有体系与题材标签。先按题材筛一遍，再决定要不要顺着某一条体系深挖，通常几分钟就能锁定几部想试读的。"
        />

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {themeTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => setActiveTag(tag)}
              aria-pressed={activeTag === tag}
              className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap cursor-pointer border transition-colors ${
                activeTag === tag
                  ? "bg-secondary-500 text-background-50 border-secondary-500"
                  : "bg-background-50 text-foreground-700 border-background-300 hover:border-secondary-400 hover:text-secondary-700"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <p className="mt-5 text-center text-sm text-foreground-500">
          当前筛选：<span className="text-foreground-950 font-medium">{activeTag}</span> · 共{" "}
          <span className="text-primary-600 font-medium">{filtered.length}</span> 部
        </p>

        {filtered.length === 0 ? (
          <div className="mt-10 rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">该题材暂时没有收录作品，换个标签看看。</p>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {filtered.map((item) => (
              <article
                key={item.title}
                className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
              >
                <div className="relative w-full h-52 bg-background-200">
                  <img
                    src={item.image}
                    alt={`《${item.title}》封面示意图`}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {item.origin}
                  </span>
                  <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-xs font-medium bg-black/55 text-background-50 flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400"></i>
                    {item.rating}
                  </span>
                </div>

                <div className="flex flex-col flex-1 p-4">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950 truncate">
                      {item.title}
                    </h3>
                    <span
                      className={`shrink-0 text-xs px-2 py-0.5 rounded-full ${
                        item.status === "连载中"
                          ? "bg-secondary-100 text-secondary-900"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.status}
                    </span>
                  </div>

                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {item.tags.map((t) => (
                      <span key={t} className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900">
                        {t}
                      </span>
                    ))}
                  </div>

                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}